//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

export function getStudyNotesConfig(studyId: number, config?: AxiosRequestConfig | undefined): Promise<Types.StudyNoteConfigDto> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/config";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStudyNotesConfig,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStudyNotesConfig(_response);
    });
}

function processGetStudyNotesConfig(response: AxiosResponse): Promise<Types.StudyNoteConfigDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StudyNoteConfigDto.fromJS(resultData200);
        return Promise.resolve<Types.StudyNoteConfigDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyNoteConfigDto>(null as any);
}

export function createStudyNotesConfig(studyId: number, dto: Types.StudyNoteConfigCreationDto, config?: AxiosRequestConfig | undefined): Promise<Types.StudyNoteConfigDto> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/config";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateStudyNotesConfig,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateStudyNotesConfig(_response);
    });
}

function processCreateStudyNotesConfig(response: AxiosResponse): Promise<Types.StudyNoteConfigDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StudyNoteConfigDto.fromJS(resultData200);
        return Promise.resolve<Types.StudyNoteConfigDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyNoteConfigDto>(null as any);
}

export function patchStudyNotesConfig(studyId: number, dto: Types.StudyNoteConfigPatchingDto, config?: AxiosRequestConfig | undefined): Promise<Types.StudyNoteConfigDto> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/config";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchStudyNotesConfig,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchStudyNotesConfig(_response);
    });
}

function processPatchStudyNotesConfig(response: AxiosResponse): Promise<Types.StudyNoteConfigDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StudyNoteConfigDto.fromJS(resultData200);
        return Promise.resolve<Types.StudyNoteConfigDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyNoteConfigDto>(null as any);
}

export function removeStudyNotesConfig(studyId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/config";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveStudyNotesConfig,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveStudyNotesConfig(_response);
    });
}

function processRemoveStudyNotesConfig(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function uploadConfigFile(studyId: number, file?: Types.FileParameter | null | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/config/files/upload";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUploadConfigFile,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUploadConfigFile(_response);
    });
}

function processUploadConfigFile(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function getStudyNotes(studyId: number, config?: AxiosRequestConfig | undefined): Promise<Types.StudyNoteResultDto[]> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/results";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStudyNotes,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStudyNotes(_response);
    });
}

function processGetStudyNotes(response: AxiosResponse): Promise<Types.StudyNoteResultDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.StudyNoteResultDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.StudyNoteResultDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyNoteResultDto[]>(null as any);
}

export function processNewStudyNote(studyId: number, dto: Types.StudyNoteProcessingDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/results/new";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigProcessNewStudyNote,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processProcessNewStudyNote(_response);
    });
}

function processProcessNewStudyNote(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function processNewStudyNoteVersion(studyId: number, resultId: number, dto: Types.StudyNoteProcessingDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/results/{resultId}/newVersion";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
    if (resultId === undefined || resultId === null)
      throw new Error("The parameter 'resultId' must be defined.");
    url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigProcessNewStudyNoteVersion,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processProcessNewStudyNoteVersion(_response);
    });
}

function processProcessNewStudyNoteVersion(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function removeStudyNote(studyId: number, resultId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/results/{resultId}";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
    if (resultId === undefined || resultId === null)
      throw new Error("The parameter 'resultId' must be defined.");
    url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveStudyNote,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveStudyNote(_response);
    });
}

function processRemoveStudyNote(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function uploadResultFile(studyId: number, file?: Types.FileParameter | null | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/notes/results/files/upload";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUploadResultFile,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUploadResultFile(_response);
    });
}

function processUploadResultFile(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}
let _requestConfigGetStudyNotesConfig: Partial<AxiosRequestConfig> | null;
export function getGetStudyNotesConfigRequestConfig() {
  return _requestConfigGetStudyNotesConfig;
}
export function setGetStudyNotesConfigRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyNotesConfig = value;
}
export function patchGetStudyNotesConfigRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyNotesConfig = patch(_requestConfigGetStudyNotesConfig ?? {});
}

let _requestConfigCreateStudyNotesConfig: Partial<AxiosRequestConfig> | null;
export function getCreateStudyNotesConfigRequestConfig() {
  return _requestConfigCreateStudyNotesConfig;
}
export function setCreateStudyNotesConfigRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateStudyNotesConfig = value;
}
export function patchCreateStudyNotesConfigRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateStudyNotesConfig = patch(_requestConfigCreateStudyNotesConfig ?? {});
}

let _requestConfigPatchStudyNotesConfig: Partial<AxiosRequestConfig> | null;
export function getPatchStudyNotesConfigRequestConfig() {
  return _requestConfigPatchStudyNotesConfig;
}
export function setPatchStudyNotesConfigRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchStudyNotesConfig = value;
}
export function patchPatchStudyNotesConfigRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchStudyNotesConfig = patch(_requestConfigPatchStudyNotesConfig ?? {});
}

let _requestConfigRemoveStudyNotesConfig: Partial<AxiosRequestConfig> | null;
export function getRemoveStudyNotesConfigRequestConfig() {
  return _requestConfigRemoveStudyNotesConfig;
}
export function setRemoveStudyNotesConfigRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveStudyNotesConfig = value;
}
export function patchRemoveStudyNotesConfigRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveStudyNotesConfig = patch(_requestConfigRemoveStudyNotesConfig ?? {});
}

let _requestConfigUploadConfigFile: Partial<AxiosRequestConfig> | null;
export function getUploadConfigFileRequestConfig() {
  return _requestConfigUploadConfigFile;
}
export function setUploadConfigFileRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUploadConfigFile = value;
}
export function patchUploadConfigFileRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUploadConfigFile = patch(_requestConfigUploadConfigFile ?? {});
}

let _requestConfigGetStudyNotes: Partial<AxiosRequestConfig> | null;
export function getGetStudyNotesRequestConfig() {
  return _requestConfigGetStudyNotes;
}
export function setGetStudyNotesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyNotes = value;
}
export function patchGetStudyNotesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyNotes = patch(_requestConfigGetStudyNotes ?? {});
}

let _requestConfigProcessNewStudyNote: Partial<AxiosRequestConfig> | null;
export function getProcessNewStudyNoteRequestConfig() {
  return _requestConfigProcessNewStudyNote;
}
export function setProcessNewStudyNoteRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigProcessNewStudyNote = value;
}
export function patchProcessNewStudyNoteRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigProcessNewStudyNote = patch(_requestConfigProcessNewStudyNote ?? {});
}

let _requestConfigProcessNewStudyNoteVersion: Partial<AxiosRequestConfig> | null;
export function getProcessNewStudyNoteVersionRequestConfig() {
  return _requestConfigProcessNewStudyNoteVersion;
}
export function setProcessNewStudyNoteVersionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigProcessNewStudyNoteVersion = value;
}
export function patchProcessNewStudyNoteVersionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigProcessNewStudyNoteVersion = patch(_requestConfigProcessNewStudyNoteVersion ?? {});
}

let _requestConfigRemoveStudyNote: Partial<AxiosRequestConfig> | null;
export function getRemoveStudyNoteRequestConfig() {
  return _requestConfigRemoveStudyNote;
}
export function setRemoveStudyNoteRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveStudyNote = value;
}
export function patchRemoveStudyNoteRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveStudyNote = patch(_requestConfigRemoveStudyNote ?? {});
}

let _requestConfigUploadResultFile: Partial<AxiosRequestConfig> | null;
export function getUploadResultFileRequestConfig() {
  return _requestConfigUploadResultFile;
}
export function setUploadResultFileRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUploadResultFile = value;
}
export function patchUploadResultFileRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUploadResultFile = patch(_requestConfigUploadResultFile ?? {});
}